/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current state of the tournament.
 * @export
 */
export const TournamentStatus = {
    DRAFT: 'DRAFT',
    REGISTRATION: 'REGISTRATION',
    READY: 'READY',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED'
} as const;
export type TournamentStatus = typeof TournamentStatus[keyof typeof TournamentStatus];


export function instanceOfTournamentStatus(value: any): boolean {
    for (const key in TournamentStatus) {
        if (Object.prototype.hasOwnProperty.call(TournamentStatus, key)) {
            if (TournamentStatus[key as keyof typeof TournamentStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TournamentStatusFromJSON(json: any): TournamentStatus {
    return TournamentStatusFromJSONTyped(json, false);
}

export function TournamentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentStatus {
    return json as TournamentStatus;
}

export function TournamentStatusToJSON(value?: TournamentStatus | null): any {
    return value as any;
}

export function TournamentStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): TournamentStatus {
    return value as TournamentStatus;
}

